function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  fill: "#CED4DA"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.3669 9.7334H4.63356C4.32189 9.7334 4.06689 9.9884 4.06689 10.3001V18.8001C4.06689 19.7351 4.83189 20.5001 5.76689 20.5001H18.2336C19.1686 20.5001 19.9336 19.7351 19.9336 18.8001V10.3001C19.9336 9.9884 19.6786 9.7334 19.3669 9.7334ZM9.16689 17.6667C9.16689 17.9784 8.91189 18.2334 8.60023 18.2334H7.46689C7.15523 18.2334 6.90023 17.9784 6.90023 17.6667V16.5334C6.90023 16.2217 7.15523 15.9667 7.46689 15.9667H8.60023C8.91189 15.9667 9.16689 16.2217 9.16689 16.5334V17.6667ZM8.60023 14.2667C8.91189 14.2667 9.16689 14.0117 9.16689 13.7001V12.5667C9.16689 12.2551 8.91189 12.0001 8.60023 12.0001H7.46689C7.15523 12.0001 6.90023 12.2551 6.90023 12.5667V13.7001C6.90023 14.0117 7.15523 14.2667 7.46689 14.2667H8.60023ZM13.1336 17.6667C13.1336 17.9784 12.8786 18.2334 12.5669 18.2334H11.4336C11.1219 18.2334 10.8669 17.9784 10.8669 17.6667V16.5334C10.8669 16.2217 11.1219 15.9667 11.4336 15.9667H12.5669C12.8786 15.9667 13.1336 16.2217 13.1336 16.5334V17.6667ZM12.5669 14.2667C12.8786 14.2667 13.1336 14.0117 13.1336 13.7001V12.5667C13.1336 12.2551 12.8786 12.0001 12.5669 12.0001H11.4336C11.1219 12.0001 10.8669 12.2551 10.8669 12.5667V13.7001C10.8669 14.0117 11.1219 14.2667 11.4336 14.2667H12.5669ZM17.1002 17.6667C17.1002 17.9784 16.8452 18.2334 16.5336 18.2334H15.4002C15.0886 18.2334 14.8336 17.9784 14.8336 17.6667V16.5334C14.8336 16.2217 15.0886 15.9667 15.4002 15.9667H16.5336C16.8452 15.9667 17.1002 16.2217 17.1002 16.5334V17.6667ZM16.5336 14.2667C16.8452 14.2667 17.1002 14.0117 17.1002 13.7001V12.5667C17.1002 12.2551 16.8452 12.0001 16.5336 12.0001H15.4002C15.0886 12.0001 14.8336 12.2551 14.8336 12.5667V13.7001C14.8336 14.0117 15.0886 14.2667 15.4002 14.2667H16.5336Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2336 5.2H16.8169V4.63333C16.8169 4.01 16.3069 3.5 15.6836 3.5C15.0602 3.5 14.5502 4.01 14.5502 4.63333V5.2H9.45023V4.63333C9.45023 4.01 8.94023 3.5 8.31689 3.5C7.69356 3.5 7.18356 4.01 7.18356 4.63333V5.2H5.76689C4.83189 5.2 4.06689 5.965 4.06689 6.9V7.46667C4.06689 7.77833 4.32189 8.03333 4.63356 8.03333H19.3669C19.6786 8.03333 19.9336 7.77833 19.9336 7.46667V6.9C19.9336 5.965 19.1686 5.2 18.2336 5.2Z",
  fill: "white"
}));

function SvgCalendarEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEvent);
export default __webpack_public_path__ + "static/media/calendar-event.aa5c8e1c.svg";
export { ForwardRef as ReactComponent };